module.exports = __webpack_public_path__ + "static/img/h4.adfc77a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/h4.jpg
// module id = UMQ0
// module chunks = 0